import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {IQApiResultObject} from '../../interfaces/interfaces.regisafe';
import {Router} from '@angular/router';
import {APP_ICON_PATH, APP_ROUTES} from '../../../environments/environment';
import {StorageService} from '../../provider/storage/storage.service';
import {SharedDataService} from '../../provider/shared-data/shared-data.service';
import {UserService} from '../../provider/user/user.service';

@Component({
	selector: 'app-regisafe-detail-subresultlist',
	templateUrl: './regisafe-detail-subresultlist.component.html',
	styleUrls: ['./regisafe-detail-subresultlist.component.scss'],
})
export class RegisafeDetailSubresultlistComponent implements OnInit, OnChanges, OnDestroy {

	@Input() result: IQApiResultObject;
	orgastruktur = '';
	firstSubStructuresInResults: Array<any> = [];
	appIconPath = APP_ICON_PATH;

	constructor(private router: Router,
				private sharedService: SharedDataService,
				private storageService: StorageService,
				private userService: UserService) {
	}

	async ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges) {
		console.log('### changes in RegisafeDetailSubresultlistComponent ###: ', changes);
		if (changes.hasOwnProperty('result')) {
			if (changes.result.currentValue.hasOwnProperty('objDatasets')) {
				this.addLabel(changes.result.currentValue.objDatasets);
			}
		}
	}

	ngOnDestroy() {
	}

	async showDetail(data: any, firstSubStructure: string) {
		// eslint-disable-next-line no-underscore-dangle
		this.router.navigate([APP_ROUTES.detail, data.osId, this.userService.objIdAsRouteParam(data._ObjID)])
			.then((navigated) => {
				// do something or leave it
			});
	}

	setFirstSubstructure(event) {
		this.firstSubStructuresInResults.push(event);
	}


	async addLabel(objDatasets) {
		Object.values(objDatasets).forEach(async (item: any) => {
			if(item.hasOwnProperty('ADatum')) {
				const osFieldDesc = await this.storageService.getOsFieldDescFromConditions(item.osId);
				item.ADatumDesc = osFieldDesc.ADatum;
				item.DatumDesc = osFieldDesc.Datum;
			}
		});
	}
}
